import { memo } from 'react';
import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormTextField from 'components/ui/form/FormTextField';
import useFormSubmit from 'hooks/useFormSubmit';

const validationSchema = yup.object({
  text: yup.string().required('tasks.staffTask.validation.comment'),
});

const TaskCommentModal = ({ open, setOpen, taskId, refetchFn }) => {
  const { t } = useTranslation();
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: { text: '' },
    validationSchema,
    onSubmit: (values) => {
      submit(
        { type: 'post', contentType: 'simple' },
        values,
        `/admin/task-staff/addcomment/${taskId}`,
        { title: t('tasks.staffTask.alerts.commented') },
        null,
        true,
        handleFinish
      );
    },
  });

  const handleFinish = () => {
    refetchFn();
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{ className: '!base-border !shadow-none' }}
      disableEscapeKeyDown
    >
      <DialogTitle className='!bg-gray-100 !mb-2 text-center'>
        {t('tasks.staffTask.commentModal.title')}
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit} className='pt-2'>
          <Grid container spacing={2} rowSpacing={1} columns={{ xs: 12 }}>
            <Grid item xs={12}>
              <FormTextField
                delay={0}
                label={t('common.fields.comment')}
                fieldName='text'
                formik={formik}
                multiline
                rows={4}
              />
            </Grid>

            <Grid item xs={12}>
              <FormActionButtons
                delay={0.2}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(TaskCommentModal);
